var _defs, _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CONTROL_ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #CONTROL_ICON .cls-1 {\n        fill: #ff7600;\n      }\n\n      #CONTROL_ICON .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_405",
    "data-name": "Pfad 405",
    className: "cls-1",
    d: "M18,0A18,18,0,1,0,36,18,18.053,18.053,0,0,0,18,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1033",
    "data-name": "Gruppe 1033",
    transform: "translate(15 14.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_406",
    "data-name": "Pfad 406",
    className: "cls-2",
    d: "M16,15.9a3,3,0,0,1-6,0c0-1.65,3-6,3-6S16,14.1,16,15.9Zm-1.65-1.05a.75.75,0,1,0,.75.75A.709.709,0,0,0,14.35,14.85Z",
    transform: "translate(-10 -9.9)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_407",
    "data-name": "Pfad 407",
    className: "cls-2",
    d: "M16.15,28.389A12.419,12.419,0,0,1,3.7,15.939a12.208,12.208,0,0,1,7.8-11.55,1.1,1.1,0,0,1,1.5.6,1.1,1.1,0,0,1-.6,1.5,9.878,9.878,0,0,0-6.45,9.45,10.2,10.2,0,1,0,20.4,0,10.427,10.427,0,0,0-6.6-9.6,1.055,1.055,0,0,1-.6-1.5,1.055,1.055,0,0,1,1.5-.6,12.68,12.68,0,0,1,8.1,11.7A12.645,12.645,0,0,1,16.15,28.389Z",
    transform: "translate(1.85 2.061)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_408",
    "data-name": "Pfad 408",
    className: "cls-2",
    d: "M12.4,11.3a1.183,1.183,0,0,1-1.2-1.2V2.6a1.183,1.183,0,0,1,1.2-1.2,1.1,1.1,0,0,1,1.2,1.2v7.5A1.183,1.183,0,0,1,12.4,11.3Z",
    transform: "translate(5.6 0.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgController);
export default __webpack_public_path__ + "static/media/controller.8e7d7b19c7d65ebc42d5dbf5cce5b9b7.svg";
export { ForwardRef as ReactComponent };